import { Box, useTheme } from '@mui/material';
import InfoSection from '../../../components/InfoSection';
import InfoGalery from '../../../components/InfoGalery';
import { tokens } from '../../../theme/theme';

export const EnergieBeratung = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const bullets = [
    'Analyse des aktuellen Gebäudezustands',
    'Entwicklung eines maßgeschneiderten Plans',
    'Aufzeigen gezielter Modernisierungsmaßnahmen',
    'Nachhaltige Senkung der Energiekosten',
  ];
  const pictures = [
    {
      webp: '/media/energy/PFLEGER BAUSERVICE ENERGY-03.webp',
      jpg: '/media/energy/PFLEGER BAUSERVICE ENERGY-03.jpg',
    },
    {
      webp: '/media/energy/PFLEGER BAUSERVICE ENERGY FILL.webp',
      jpg: '/media/energy/PFLEGER BAUSERVICE ENERGY FILL.jpg',
      opacity: 0.2,
    },
  ];

  return (
    <Box className="h-full w-full flex flex-col xl:flex-row justify-between items-center p-2 md:p-10 overflow-hidden gap-4">
      <InfoSection
        number={1}
        title="Energieberatung"
        subTitle="Ihre Garantie für ein solides Bauprojekt."
        bulletArray={bullets}
        color={colors.energy[500]}
      />
      <InfoGalery pictures={pictures} />
    </Box>
  );
};
